import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

import _ from 'lodash';
import { useNavigate } from 'react-router-dom';

export default function Home () {
  const isHubEnabled = useSelector((state: any) => _.get(state, "accounts.item.hubEnabled"));

  const navigate = useNavigate();

  useEffect(() => {
    if (isHubEnabled) {
      navigate("/hub");
    } else {
      navigate("/collections");
    }
  }, [isHubEnabled]);
    
  return <></>;
}
